define('SageDotCom/DataLayer/global',['jquery',
    'SageDotCom/DataLayer/Global/buttons',
    'SageDotCom/DataLayer/Global/tabsets',
    'SageDotCom/DataLayer/Global/scrolling',
    'SageDotCom/DataLayer/Global/imageButtons',
    'SageDotCom/DataLayer/Global/accordions',
    'SageDotCom/DataLayer/Global/search',
    'SageDotCom/DataLayer/Global/footer',
    'SageDotCom/DataLayer/Global/links',
    'SageDotCom/DataLayer/Global/header-menu-tracker',
    'SageDotCom/DataLayer/Global/carousel',
    'SageDotCom/DataLayer/Global/slider',
    'SageDotCom/DataLayer/Global/pageVisuals',
    'SageDotCom/DataLayer/Global/sticky-nav-tracker',
    'SageDotCom/DataLayer/Global/forms',
    'SageDotCom/DataLayer/Global/feedback',
    'SageDotCom/DataLayer/Global/iAdvizeCallBack',
    'SageDotCom/DataLayer/Global/generic-video-tracker',
    'SageDotCom/DataLayer/Global/brightcove-video-tracker',
    'SageDotCom/DataLayer/Global/ccaas-chat-tracker',
    'SageDotCom/DataLayer/Global/product-list-tracker'
],
    function (
        $,
        buttons,
        tabs,
        scrolling,
        imageButtons,
        accordions,
        search,
        footer,
        links,
        HeaderMenuTracker,
        carousel,
        slider,
        pageVisuals,
        StickyNavTracker,
        forms,
        FeedbackTracker,
        iAdvizeCallBackTracker,
        GenericVideoTracker,
        BrightcoveVideoTracker,
        CcaasChatTracker,
        ProductListTracker
    ) {

        function globalLoader() { }
        function initialize() {
            if (!window.BrainJocks.EE) {
                // initialize each tracking type into it's own event on the internal JS event queue
                // to prevent pages from 'hanging' as the tracking is being applied to elements
                setTimeout(tabs.initialize.bind(tabs), 0);
                setTimeout(buttons.initialize.bind(buttons), 0);
                setTimeout(scrolling.initialize.bind(scrolling), 0);
                setTimeout(imageButtons.initialize.bind(imageButtons), 0);
                setTimeout(accordions.initialize.bind(accordions), 0);
                setTimeout(search.initialize.bind(search), 0);
                setTimeout(footer.initialize.bind(footer), 0);
                setTimeout(links.initialize.bind(links), 0);
                setTimeout(HeaderMenuTracker.prototype.start.bind(new HeaderMenuTracker()), 0);
                setTimeout(carousel.initialize.bind(carousel), 0);
                setTimeout(slider.initialize.bind(slider), 0);
                setTimeout(pageVisuals.initialize.bind(pageVisuals), 0);
                setTimeout(StickyNavTracker.prototype.start.bind(new StickyNavTracker()), 0);
                setTimeout(forms.initialize.bind(forms), 0);
                setTimeout(FeedbackTracker.prototype.start.bind(new FeedbackTracker()), 0);
                setTimeout(iAdvizeCallBackTracker.prototype.start.bind(new iAdvizeCallBackTracker()), 0);
                setTimeout(new GenericVideoTracker().start, 0);
                setTimeout(new BrightcoveVideoTracker().start, 0);
                setTimeout(CcaasChatTracker.prototype.start.bind(new CcaasChatTracker()), 0);
                setTimeout(ProductListTracker.prototype.start.bind(new ProductListTracker()), 0);
            }
        };
        document.addEventListener("spaPageChanged", function () {            
            initialize();
        });

        globalLoader.prototype.initialize = initialize;

        return new globalLoader();
    });
